var App = App || {};

App.WhySelfHelpBand = (function ($) {
    "use strict";

    function init() {

        const whySelfHelpBands = $(".widget.widget-why-self-help-band");
        if (whySelfHelpBands.length) {
            whySelfHelpBands.each(function () {
                const whySelfHelpBand = $(this);
                const bandContent = whySelfHelpBand.find(".why-self-help-content");
                const itemCount = bandContent.attr("data-count");
                const toggleBtn = whySelfHelpBand.find(".wshb-toggle");

                var interval;
                var process = true;

                var timer = function () {
                    interval = setInterval(function () {
                        if (process) {
                            nextSlide(bandContent, itemCount);
                        }
                    }, 4000);
                };
                timer();

                toggleBtn.on("click", function () {
                    $(this).toggleClass("play");
                    process = !process;

                    clearInterval(interval);
                    timer();
                });
            });
        }
    }

    function nextSlide(bandContent, cardCount) {
        var activeItem = bandContent.find(".item-text.active");
        activeItem.removeClass("active opaque").attr("aria-hidden", "true");

        var currentIndex = activeItem.attr("data-index");
        var nextIndex = currentIndex == cardCount ? 1 : nextIndex = parseInt(currentIndex) + 1;

        var nextSlide = bandContent.find(".item-text[data-index=" + nextIndex + "]");
        nextSlide.addClass("active").attr("aria-hidden", "false");
        setTimeout(() => {
            nextSlide.addClass("opaque")
        }, 10);
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.WhySelfHelpBand.init();
});